module.exports = __webpack_public_path__ + "img/20171113190945_25790.be7cbc6c.jpg";